import { render, staticRenderFns } from "./TrustpilotSection.vue?vue&type=template&id=1133b544&scoped=true&"
import script from "./TrustpilotSection.vue?vue&type=script&lang=js&"
export * from "./TrustpilotSection.vue?vue&type=script&lang=js&"
import style0 from "./TrustpilotSection.vue?vue&type=style&index=0&id=1133b544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133b544",
  null
  
)

export default component.exports